import { render, staticRenderFns } from "./tabSwitch.vue?vue&type=template&id=eb773d10&scoped=true&"
import script from "./tabSwitch.vue?vue&type=script&lang=js&"
export * from "./tabSwitch.vue?vue&type=script&lang=js&"
import style0 from "./tabSwitch.vue?vue&type=style&index=0&id=eb773d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb773d10",
  null
  
)

export default component.exports